import type { CaseStudy } from '../types/work';

export const caseStudies: CaseStudy[] = [
  {
    slug: 'ai-operations-system',
    index: '01',
    title: 'AI Operations System',
    category: 'AI Strategy · Product · Automation',
    year: '2026',
    accent: 'coral',
    headline: 'Turning scattered work into one intelligent operating rhythm.',
    summary:
      'A practical AI operating system that connects knowledge, decisions, and repetitive workflows across a growing service business.',
    challenge:
      'The team was moving quickly, but information lived across documents, chats, and individual memory. Repeated manual work slowed delivery and made quality difficult to scale.',
    approach:
      'I mapped the highest-friction workflows, designed a shared knowledge architecture, and introduced focused AI copilots where they could remove real work without adding complexity.',
    outcome:
      'A clearer operating model, faster access to trusted knowledge, and repeatable workflows that give the team more time for judgment and customer work.',
    metrics: [
      ['Clearer', 'access to trusted knowledge'],
      ['Focused', 'AI copilots for real work'],
      ['One', 'connected operating rhythm'],
    ],
  },
  {
    slug: 'product-growth-engine',
    index: '02',
    title: 'Product Growth Engine',
    category: 'Product Leadership · Growth',
    year: '2025',
    accent: 'lime',
    headline: 'From a crowded roadmap to a product people understand and use.',
    summary:
      'Reframing product strategy around the customer journey, commercial value, and a smaller set of high-conviction bets.',
    challenge:
      'A long feature list created motion without momentum. Teams lacked a shared definition of value and customers struggled to see the product’s clearest advantage.',
    approach:
      'I rebuilt discovery around customer outcomes, created a decision framework for roadmap choices, and aligned product, engineering, success, and go-to-market around one narrative.',
    outcome:
      'Sharper priorities, shorter feedback loops, and a product story that connects what the team ships to why customers buy and stay.',
    metrics: [
      ['Clearer', 'customer outcomes'],
      ['Smaller', 'set of high-conviction bets'],
      ['Closer', 'feedback loops'],
    ],
  },
  {
    slug: 'business-scale-blueprint',
    index: '03',
    title: 'Business Scale Blueprint',
    category: 'Business Strategy · Operations',
    year: '2024',
    accent: 'violet',
    headline: 'Building the systems a growing business needs before it feels the strain.',
    summary:
      'A practical blueprint connecting positioning, delivery, team ownership, and commercial operations for sustainable growth.',
    challenge:
      'Growth exposed unclear ownership, inconsistent delivery, and reactive decisions. The business needed structure without losing its speed or entrepreneurial energy.',
    approach:
      'I connected strategy to weekly operations: clarifying the offer, redesigning delivery stages, assigning decision ownership, and creating a small set of useful business signals.',
    outcome:
      'More predictable delivery, clearer accountability, healthier client conversations, and an operating foundation designed to grow with the company.',
    metrics: [
      ['Clearer', 'ownership across the business'],
      ['Healthier', 'client conversations'],
      ['Shared', 'growth plan'],
    ],
  },
];
